<script>
import render from '@/render/render'
import { copy } from '@/utils'
export default {
    name: 'Tabs',
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        tabPosition: {
            type: String,
            default: 'top'
        },
        type: {
            type: String,
            default: ''
        },
        tabs: {
            type: Array,
            default: () => [],
        }
    },
    watch: {
        value: {
            handler(value) {
                if(Array.isArray(value)) {
                   this.info = copy(value)
                }
            },
            deep: true,
            immediate: true,
        },
        propTabs: {
            handler(value) {
                const { eventHub, __vModel__ } = this.$attrs
                eventHub.emit('designProps', { property: 'tabs', data: value, key: __vModel__} )
            },
            deep: true
        }
    },
    created() {
        const { componentToRegister, design } = this.$attrs
        if(design) {
            this.design = true
        }
        if(Array.isArray(componentToRegister)) {
            const [DraggableItem, draggable] = componentToRegister
            console.log(componentToRegister, componentToRegister.name)
            this.$options.components['draggable-item'] = DraggableItem
            this.$options.components['draggable'] = draggable
        }
    },
    data() {
        return {
            activeName: '',
            info: [],
            design: false,
            propTabs: copy(this.tabs)
        }
    },
    render() {
        const { tabPosition, type, tabs, propTabs } = this
        const { formSlot: { scopedSlots } } = this.$attrs
        this.activeName = Array.isArray(tabs) && tabs[0] && tabs[0].label
        const setValue = (label, key, value) => {
            console.log(label, key, value)
            const data = this.info
            const item = data.find(item => item.label === label)
            if(item) {
                if(item.data) {
                    item.data[key] = value
                }
            } else {
                data.push({
                    label: label,
                    data: {
                        [key]: value
                    }
                })
            }
            this.$emit('input', data)
        }
        console.log('slots-default', this.$slots.default)
        const { design } = this.$attrs
        return (
            <el-tabs v-model={this.activeName} onTab-click={(tab, event) => {}} type={type} tab-position={tabPosition}>
                {
                    propTabs.map(tab => (
                        <el-tab-pane label={tab.label} name={tab.label}>
                            {
                                design ? (
                                    <div>
                                        <draggable list={tab.rows} animation={340} group="componentsGroup">
                                            {
                                                tab.rows.map((item, index) => {
                                                    return (
                                                        <draggable-item 
                                                            key={index}
                                                            current-item={item}
                                                            drawing-list={tab.rows}
                                                            index={index}
                                                            in-table={true}
                                                            onActiveItem={item => {
                                                                const { eventHub } = this.$attrs
                                                                eventHub.emit('activeItem', item )
                                                            }}
                                                            onDeleteItem={index => tab.rows.splice(index, 1)}
                                                        />
                                                    )
                                                })
                                            }
                                        </draggable>
                                        <div style="color: #c0bebe; text-align: center; width: 90%; padding: 5px">
                                            ☝ 拖拽控件到表格内部
                                        </div>
                                    </div>
                                ) :
                                tab.rows.map( item => {
                                    const { __vModel__, __config__ } = item
                                    const { span, showLabel, label } = __config__
                                    let info
                                    const tabItem = this.info.find(item => item.label === tab.label)
                                    if(tabItem) {
                                        info = tabItem.data
                                    } else {
                                        info = {}
                                    }
                                    return (
                                        <el-col span={span} style="padding: 5px 0">
                                            <el-form-item label-width="120px" prop={__vModel__} label={showLabel ? label : ""}>
                                                <render info={info} formSlot={{scopedSlots}} conf={item} onInput={value => setValue(tab.label, __vModel__, value)} attrs={this.$attrs} />
                                            </el-form-item>
                                        </el-col>
                                    )
                                })
                            }
                        </el-tab-pane>
                    ))
                }
            </el-tabs>
        )
    }
}
</script>